import { SxProps, Theme, Typography } from '@mui/material';

interface MetricsSectionTitleProps {
  subtitle?: React.ReactNode;
  sx?: SxProps<Theme>;
  additionalTitle?: React.ReactNode;
  rightComponent?: React.ReactNode;
}

export function MetricsSectionTitle({
  children,
  additionalTitle = null,
  subtitle = null,
  rightComponent = null,
}: React.PropsWithChildren<MetricsSectionTitleProps>) {
  return (
    <div className="w-full">
      <div className="flex justify-between">
        <div className="flex flex-row items-center pt-2">
          <div className="flex flex-row gap-2 items-center">
            <Typography variant="h3" gutterBottom>
              {children}
            </Typography>
            {additionalTitle && (
              <Typography variant="body2" gutterBottom>
                {additionalTitle}
              </Typography>
            )}
          </div>
        </div>
        {rightComponent}
      </div>
      {subtitle ? <p className="text-xs text-text-secondary">{subtitle}</p> : ''}
    </div>
  );
}
